export const removeEmojis = (str: string): string => {
  return str.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\u24C2|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDFFF])/g, "");
};